import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { GfyView, NewsletterSubscribeFormView } from '../../components';
import './style.scss';

// @todo: convert this to a presentational component

class NewsletterView extends React.Component {

  render() {
    return (
      <div id="newsletter-form">
        <div className="bg-fff-80">
          <div className="container-fluid content">
            <div className="row">
              <div className="newsletter col-12">
                <div className="row">
                  <div className="col-12 col-lg-6 p-0 subscribe-text">
                    <div
                      className="text-uppercase pr-10 panel-title d-inline-block">
                      Subscribe
                    </div>
                    <div
                      className="panel-label u-font-foundation-light pl-10 d-inline-block">
                       to the Daily Dose of Love Newsletter
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 p-0">
                    <div className="newsletter-fields-wrap">
                      <NewsletterSubscribeFormView/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(NewsletterView);
